
export const LoadingText = () => {
  return (
    <div className='loading w-3/4 h-4 rounded-md'></div>
  )
}
